import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    Button,
    Table,
    Input,
    InputNumber,
    Modal,
    message,
    Select,
    Form,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class MttTicketList extends React.Component {
    state = {
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            uid: undefined,
            satelliteId: undefined,
            mainId: undefined,
        },
        data: [], // 表格数据
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/mtt/ticket/list", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                if (res.code === 200) {
                    this.setState({
                        loading: false,
                        queryParams: { ...this.state.queryParams, total: res.count || 0 },
                        data: res.data || [],
                    });
                }
            });
    };

    /**
     * 注销
     */
    handleLogOut = (id) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["destroyTicketConfirm"],
            onOk: () => {
                axios.post("/v1/api/mtt/ticket/cancel", { id }).then((res) => {
                    if (res.code === 200) {
                        message.success(this.props.language["destroySuccessMessage"]);
                        this.fetchData();
                    }
                });
            },
        });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    uid: undefined,
                    satelliteId: undefined,
                    mainId: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["uidPlaceholder"]}
                        value={this.state.queryParams.uid}
                        onChange={(value) => this.handleSetQueryParamsData("uid", value)}
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["satelliteMatchMidPlaceholder"]}
                        value={this.state.queryParams.satelliteId}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("satelliteId", value)
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["mainMatchMidPlaceholder"]}
                        value={this.state.queryParams.mainId}
                        onChange={(value) => this.handleSetQueryParamsData("mainId", value)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["uid"]}
                            dataIndex="uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["satelliteMatchMid"]}
                            dataIndex="satellite_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["satelliteName"]}
                            dataIndex="satellite_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mainMatchMid"]}
                            dataIndex="main_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mainMatchName"]}
                            dataIndex="main_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ticketId"]}
                            dataIndex="id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex="status"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["statusUpdateTime"]}
                            dataIndex="updateAt"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            render={(item) => (
                                <Button
                                    type="danger"
                                    ghost
                                    disabled={item.status === this.props.language["cancelled"]}
                                    onClick={() => this.handleLogOut(item.id)}
                                >
                                    {this.props.language["writeOff"]}
                                </Button>
                            )}
                        />
                    </Table>
                </div>
            </div>
        );
    }
}